import TokenService from "@/services/storage.service.js";
import router from "@/router";
import store from "@/store";

// import router from "./router";

const $tokenService = new TokenService();

const getDefaultState = () => {
	return {
		authenticated: false,
		token: null,
		// emailVerified: false,
	};
};

const Auth = {
	namespaced: true,

	state: getDefaultState(),

	mutations: {
		SET_TOKEN: (state, token) => {
			state.token = token;
		},

		UNSET_TOKEN: state => {
			$tokenService.removeToken();
			state.token = null;
		},

		UNSET_ACTIVE_ACCOUNT: () => {
			localStorage.removeItem("activeAccount");
		},

		RESET_STATE: state => {
			Object.assign(state, getDefaultState());
		},
	},
	actions: {
		setToken: ({ commit }) => {
			commit("SET_TOKEN", $tokenService.getToken());
		},

		auth: async ({ commit, dispatch }) => {
			// if we are forcing to refresh the access token
			if (localStorage.getItem('refreshToken')) {
				localStorage.removeItem('refreshToken');

				const response = await Vue.prototype.$apiService.get('refresh-token');
				if (response.data.access_token) {
					$tokenService.saveToken(response.data.access_token);
					Vue.prototype.$apiService.setBearer();
					Vue.prototype.$apiService.mountInterceptor401();
				}
			}

			commit("SET_TOKEN", $tokenService.getToken());

			try {
				await dispatch("User/fetchUser", null, { root: true });
				dispatch("Roles/fetchRoles", null, { root: true });

				return true;
			} catch (error) {
				return false;
			}
		},

		login: ({ dispatch }, payload) => {
			return Vue.prototype.$apiService
				.post("login", payload)
				.then(async response => {
					if (response.data['2fa_enable']) return '2FA';

					return await dispatch('processLoginResponse', response);
				})
				.catch(err => {
					return "incorrect";
				});
		},

		processLoginResponse: async ({ commit, dispatch, rootState }, response) => {
			if (!response.data.access_token) return;

			$tokenService.saveToken(response.data.access_token);
			Vue.prototype.$apiService.setBearer();
			Vue.prototype.$apiService.mountInterceptor401();

			commit('SET_TOKEN', response.data.access_token);
			await dispatch('User/fetchUser', null, { root: true });
			// commit("User/SET_USER", response.data.user, { root: true });
			// commit("User/SET_ACTIVE_ACCOUNT", null, { root: true });
			dispatch('Roles/fetchRoles', null, { root: true });

			if (response.data.user.email_verified_at) {
				if (!rootState.Plans.selectablePlans.map(plan => plan.id).includes(rootState.User.account.plan_id)) {
					dispatch("signout", false);
					return 'wrong-account';
				}

				router.push({ name: 'app' });
			}
			else router.push({ name: 'verify-email' });
		},

		signout: ({ dispatch }, redirect = true) => {
			Vue.prototype.$apiService.get('logout');
			dispatch("resetAll", null, { root: true });
			if (redirect) {
				router.push({ name: "login" });
				setTimeout(() => {
					router.go();
				}, 100);
			}
		},

		resetState: ({ commit }) => {
			commit("UNSET_TOKEN");
			commit("UNSET_ACTIVE_ACCOUNT");
			commit("RESET_STATE");
		},

		unsetActiveAccount: ({ commit }) => {
			commit("UNSET_ACTIVE_ACCOUNT");
		},

		// 2FA
		generateSecret: () => {
			return Vue.prototype.$apiService.post("generate2faSecret");
		},

		generateQRCode: () => {
			return Vue.prototype.$apiService.get("generate2faQRcode");
		},

		enable2FA: ({ commit }, payload) => {
			return Vue.prototype.$apiService.post("enable2fa", { verify_code: payload })
				.then(success => {
					return success;
				})
				.catch(err => {
					return err.response;
				})
		},

		disable2FA: ({ commit }, payload) => {
			return Vue.prototype.$apiService.post("disable2fa", {
				password: payload.password,
				verify_code: payload.code
			})
				.then(success => {
					return success;
				})
				.catch(err => {
					return err.response;
				})
		},

		download2FARecoveryCodes: () => {
			return Vue.prototype.$apiService.get('downloadGenerated2faRecoveryCodes');
		},

		recovery: ({ commit }, payload) => {
			return Vue.prototype.$apiService.post('recovery', { recovery_code: payload });
		},

		login2FA: ({ dispatch }, payload) => {
			return Vue.prototype.$apiService.post('verify2fa', payload)
				.then(async response => {
					return await dispatch('processLoginResponse', response);
				}).catch(err => {
					return err.response;
				})
		},
	},
	getters: {},
};

export default Auth;
